import { Box, Button, Stack, Typography } from "@mui/material";
import { memo } from "react";
import { getCreatedTimeText, useMessageStyle } from "./ChatItem.helper";
import clsx from "clsx";
import { getCommonLang, getNSLang } from "utils/lang.utils";
import { KeyConstant, LangConstant, SystemConstant } from "const";
import { styled } from "@mui/styles";
import { AppAvatar } from "components";
import { StorageUtil } from "utils";
import ThreadParentLine from "./ThreadParentLine";
import { SCROLL_TRIGGER_CLASS } from "../useQueryMessage";
import { PinFilledIcon, TimerIcon } from "components/icons";

const DeleteMessage = ({ message }) => {
  const messengerClasses = useMessageStyle();
  const msgCreatedTime = getCreatedTimeText(message);
  const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID);
  const isMine = message.senderId === accountId;
  const isNotFoundMessage = message.sendType === SystemConstant.SEND_TYPE.notFound;

  let content = "";
  if (message.isDeleteOnlyMe) {
    content = getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_DELETE_ONLY_ME");
  } else if (isNotFoundMessage) {
    content = getCommonLang("TXT_NOT_FOUND_MESSAGE");
  } else if (message.isDeleteAll) {
    content = getNSLang(LangConstant.NS_HOME_CONVERSATION, "TXT_DELETE_MSG_ALL");
  }

  return (
    <Stack direction="row" spacing={2}>
      {!isMine && (
        <AppAvatar
          avatarId={message.avatarId}
          size={40}
          className={clsx(!Boolean(message.isAvatar) && messengerClasses.hiddenAvatar)}
          alt="chatting-avatar"
        />
      )}
      <Box>
        {msgCreatedTime && (
          <Stack direction="row" spacing={0.5} alignItems="center">
            {message.isDisappear && <TimerIcon />}
            <Typography className={clsx("ellipsis", messengerClasses.createdTimeText, "msg-sender-time")}>
              {msgCreatedTime}
            </Typography>
          </Stack>
        )}

        {Boolean(message.sendAsDirectMessage) && <ThreadParentLine message={message} />}

        <Stack direction={isMine ? "row-reverse" : "row"}>
          <DeleteContainer variant="outlined" disabled className={SCROLL_TRIGGER_CLASS}>
            {content}
          </DeleteContainer>

          {(message.isPin || message.isDisappear) && (
            <Stack justifyContent="space-between" mr={0.5}>
              <Box>{message.isPin && <PinFilledIcon />}</Box>
              {isMine && message.isDisappear && <TimerIcon />}
            </Stack>
          )}
        </Stack>
      </Box>
    </Stack>
  );
};

export default memo(DeleteMessage);

const DeleteContainer = styled(Button)({
  textTransform: "none",
  borderRadius: 12,
  padding: "12px 16px",

  "&:disabled": {
    color: "rgb(0 0 0 / 30%)",
    backgroundColor: "#F5F5F5",
    border: "none",
  },
});
